import {ADD_TEXT, START, SUCCESS, FAIL} from "../constants/action-types";
import Mediator from "../services/Mediator";
import isDarkColor from "../services/lib/is-dark-color";

const isDarkDesign = (design) => {
  return design && design.background && isDarkColor(design.background);
};

const isBlackProduct = (variants) => {
  return variants && variants.color === `black`;
};

export const addText = (text = `Впишите\nтекст`) => (dispatch, getState) => {
  dispatch({
    type: ADD_TEXT + START
  });
  (async () => {
    try {
      const {
        condition: {variants, design}
      } = getState();
      const {
        color,
        fontFamily,
        fontSize,
        fontWeight,
        textDecoration,
        shadow,
        fontStyle,
        stroke,
        strokeWidth,
        textAlign,
        lineHeight,
        textBackgroundColor,
        fill
      } = await Mediator.addTextToCanvas(text, {
        fill: isBlackProduct(variants) || isDarkDesign(design) ? `#fff` : `#000`
      });
      dispatch({
        type: ADD_TEXT + SUCCESS,
        payload: {
          color,
          fontFamily,
          fontSize,
          fontWeight,
          textDecoration,
          shadow,
          fontStyle,
          stroke,
          strokeWidth,
          textAlign,
          lineHeight,
          textBackgroundColor,
          fill
        }
      });
    } catch (error) {
      dispatch({
        type: ADD_TEXT + FAIL,
        error
      });
    }
  })();
};
